<ng-container *ngIf="canView">
    <mat-expansion-panel *ngIf="!isValidating" [expanded]="true" style="margin: 10px 0px;">

        <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon style="margin-top: -3px; margin-right: 5px;">attach_money</mat-icon>
                Mis Expensas
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
        </mat-expansion-panel-header>

        <div fxLayout="row stretch" fxLayout.xs="column">
            <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="end end" class="flex-item">
                <a style="cursor: pointer; margin: 5px;" (click)="viewAll()" *ngIf="canViewDetalle" [routerLink]="">
                  <mat-label>Ver todas las expensas</mat-label>
                </a>
            </div>
        </div>

        <div fxLayout="row stretch" fxLayout.xs="column">
            <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
                <ejs-grid #grid [dataSource]='data' [query]='query' [allowPaging]="false" [allowSorting]="true" [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' 
                    [pageSettings]='pageSettings' [allowResizing]='true' (actionFailure)="onGridActionFailure($event)">
                    <e-columns>
                        <e-column field='ExpensaPeriodo' headerText='Período' width=100></e-column>
                        <e-column field='ComunidadNombre' headerText='Comunidad' width=120>
                            <ng-template #headerTemplate let-data>
                                {{'Comunidad' | translate}}
                            </ng-template>
                        </e-column>
                        <e-column field='MiImporte' headerText='Mi Importe' width=120 textAlign="right">
                            <ng-template #template let-data>
                                {{data.Moneda}} {{data.MiImporte | number:'1.2-2'}}
                            </ng-template>
                        </e-column>
                        <e-column field='Importe' headerText='Importe' width=120 textAlign="right">
                            <ng-template #template let-data>
                                {{data.Moneda}} {{data.Importe | number:'1.2-2'}}
                            </ng-template>
                        </e-column>
                        <e-column field='FechaVencimiento' headerText='Vencimiento' width=100>
                            <ng-template #template let-data>
                                {{data.FechaVencimiento | date:'dd/MM/yyyy'}}
                            </ng-template>
                        </e-column>
                        <e-column headerText='' width=70>
                            <ng-template #template let-data>
                                <a style="cursor: pointer; margin-right: 5px" (click)="view(data)" *ngIf="canViewDetalle"><i class="fa fa-eye fa-1x"></i></a>
                            </ng-template>
                        </e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </div>

    </mat-expansion-panel>
</ng-container>